import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalReason } from '@/types/vehicle-withdrawal-reason'
import { AxiosResponse } from 'axios'

export function createVehicleWithdrawalReason(
  body: Partial<VehicleWithdrawalReason>
): Promise<AxiosResponse<VehicleWithdrawalReason>> {
  return instance.post(`/vehicle-withdrawal-reason`, body)
}
